import axios from 'axios';
import { clearSession, getToken } from '../auth/session';
import { getApiBaseUrl } from '../config/apiBaseUrl';

export const API_BASE_URL = getApiBaseUrl();

const http = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

const looksLikeHtml = (data) =>
  typeof data === 'string' && /^\s*</.test(data);

http.interceptors.response.use(
  (response) => {
    const contentType = String(response.headers?.['content-type'] || '');
    if (contentType.includes('text/html') || looksLikeHtml(response.data)) {
      const url = `${response.config?.baseURL || ''}${response.config?.url || ''}`;
      return Promise.reject(
        new Error(
          `API returned HTML instead of JSON from ${url || 'unknown URL'}. ` +
            'The client is calling the web app host instead of the API, or a stale bundle is still loaded. Hard-refresh and retry.'
        )
      );
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      clearSession();
      const path = window.location.pathname;
      if (!path.includes('/login') && !path.includes('/signup')) {
        window.location.href = '/login';
      }
    }
    const data = error.response?.data;
    const contentType = String(error.response?.headers?.['content-type'] || '');
    if (contentType.includes('text/html') || looksLikeHtml(data)) {
      const url = `${error.config?.baseURL || ''}${error.config?.url || ''}`;
      error.message =
        `API returned HTML instead of JSON from ${url || 'unknown URL'}. ` +
        'Hard-refresh to load the latest client bundle, then retry.';
    }
    return Promise.reject(error);
  }
);

export const unwrap = (payload) => payload?.data ?? payload;

export default http;
